import gsap from "gsap";
import { CAMPICHE_SUPPRESS_TOPBAR_SCROLL_KEY } from "./sidebar-anchors.js";

export default {
  init() {
    const topbar = document.querySelector(".topbar");
    const footer = document.querySelector(".footer");
    let lastScrollTop = 0;
    let currentScroll = 0;
    let scrollDirection;
    let scrollOffset = 400;
    let isSticky = false;
    let isOffset = false;

    const stick = (el) => {
      el.classList.add("is-sticky");
      isSticky = true;
    };

    const unstick = (el) => {
      el.classList.remove("is-sticky");
      isSticky = false;
    };

    const offset = (el, duration) => {
      gsap.to(el, {
        y: "-100%",
        duration: duration,
      });
      el.classList.add("is-offset");
      isOffset = true;
    };

    const unoffset = (el, duration) => {
      gsap.to(el, {
        y: 0,
        duration: duration,
        onComplete: () => {
          el.style.transform = "none";
        },
      });
      el.classList.remove("is-offset");
      isOffset = false;
    };

    window.addEventListener("scroll", () => {
      currentScroll = window.scrollY;
      scrollDirection = currentScroll > lastScrollTop ? "down" : "up";
      const footerTop = footer.getBoundingClientRect().top;

      const suppressForAnchorNav = window[CAMPICHE_SUPPRESS_TOPBAR_SCROLL_KEY];
      if (suppressForAnchorNav) {
        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
        return;
      }

      if (scrollDirection === "down" && currentScroll > scrollOffset) {
        if (!isSticky) {
          stick(topbar);
          offset(topbar, 0);
        }

        if (!topbar.classList.contains("is-offset")) {
          offset(topbar, 0.3);
        }
      }

      if (
        scrollDirection === "up" &&
        isSticky &&
        footerTop > window.innerHeight / 2
      ) {
        if (lastScrollTop - currentScroll > 15) {
          unoffset(topbar, 0.3);
        }

        if (currentScroll <= 0) {
          unstick(topbar);
        }
      }

      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    });
  },
};
